import config from "../../../config"; // Pages

import { LandForSalePage } from "./land-for-sale";
var masterplan = config.routes.get("landforsale.masterplan");
export var Routes = [{
  name: "Masterplan",
  path: "".concat(masterplan, "/:neighbourhoodOrRelease?/:releaseOrLot?/:lotOrLotID?/:lotID?"),
  component: LandForSalePage
}];
export * from "./land-for-sale";